"use client";

import { CLink } from "@/components/common/customLink/CustomLink";
import Button from "@/components/ui/button/Button";
import Modal from "@/components/ui/modal_new/Modal";
import { useGlobalStore } from "@/store/store";
import { FC } from "react";

type QuitConfirmationModalProps = {
  translations?: Record<string, string>;
  isOpen: boolean;
  toggle: () => void;
  bookingDate?: string;
};

const QuitConfirmationModal: FC<QuitConfirmationModalProps> = ({
  translations,
  isOpen,
  toggle,
  bookingDate,
}) => {
  const { user } = useGlobalStore();
  
  // Determine redirect URL based on user authentication status
  const redirectUrl = user ? "/my-account/eye-test-reservations" : "/";
  return (
    <Modal
      isOpen={isOpen}
      onClose={toggle}
      slots={{
        container: { style: { width: "23.938rem" } },
        root: { className: "z-[25]" },
        // container: { className: "w-full sm:w-[23.938rem]" },
      }}
    >
      <div className="w-full pr-8" style={{ paddingRight: "2rem" }}>
        <div className="font-semibold">{translations?.quit_modal_title}</div>
        <div className="mt-4 text-sm font-normal">
          {translations?.quit_modal_message?.replace("{{date}}", bookingDate ?? "")}
        </div>
        <div className="mb-4 mt-8 flex items-center justify-start gap-4">
          <Button
            className="flex w-full items-center justify-center border-2 border-black bg-transparent text-[0.875rem] font-bold text-black"
            style={{ height: "3rem", width: "fit-content", textAlign: "center" }}
            onClick={toggle}
          >
            {translations?.quit_modal_cancel_button_label}
          </Button>
          <CLink href={redirectUrl}>
            <Button
              className="flex w-full items-center justify-center whitespace-nowrap text-[0.875rem] font-bold"
              style={{ height: "3rem", width: "fit-content", textAlign: "center" }}
            >
              {translations?.quit_modal_confirm_button_label}
            </Button>
          </CLink>
        </div>
      </div>
    </Modal>
  );
};

export default QuitConfirmationModal;
